/**
 * MulticallerWithSender ABI
 *
 * A multicaller contract that preserves the original msg.sender for authorization checks.
 * Deployed at 0x00000000002Fd5Aeb385D324B580FCa7c83823A0 on most chains.
 *
 * Target contracts can read the original sender via LibMulticaller.sender() or
 * LibMulticaller.senderOrSigner() which calls this contract's receive() to get the stored sender.
 */
export const multicallerWithSenderAbi = [
	{
		type: "function",
		name: "aggregateWithSender",
		inputs: [
			{ name: "targets", type: "address[]" },
			{ name: "data", type: "bytes[]" },
			{ name: "values", type: "uint256[]" },
		],
		outputs: [{ name: "", type: "bytes[]" }],
		stateMutability: "payable",
	},
	{
		type: "receive",
		stateMutability: "payable",
	},
	{
		type: "error",
		name: "ArrayLengthsMismatch",
		inputs: [],
	},
	{
		type: "error",
		name: "Reentrancy",
		inputs: [],
	},
] as const

/**
 * MulticallerWithSender address - deployed via CREATE2 with deterministic address
 * https://github.com/Vectorized/multicaller
 */
export const MULTICALLER_WITH_SENDER_ADDRESS = "0x00000000002Fd5Aeb385D324B580FCa7c83823A0" as const
